import { createPortal } from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from '@scholastic/mockingjay';
import { routes } from '@/routes';

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      {/* Portal to body so the toaster escapes the `#root { isolation: isolate }`
          stacking context and renders above modal dialogs, whose overlays Radix
          also portals to body. */}
      {createPortal(<Toaster />, document.body)}
    </>
  );
}
